import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {
    PageState
} from './veranstaltungen-info-kategorien.reducer';
import {Observable} from 'rxjs';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../../websocket.actions';
import {VeranstaltungenEntityTypes} from '../../../../client-constants';
import VERANSTALTUNG_ENTITY_PART_INFO_KATEGORIE = VeranstaltungenEntityTypes.VERANSTALTUNG_ENTITY_PART_INFO_KATEGORIE;
import VERANSTALTUNG_ENTITY = VeranstaltungenEntityTypes.VERANSTALTUNG_ENTITY;
import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import {
    VeranstaltungDetail
} from '../../../../clients/veranstaltungen';
import {GetVeranstaltungInfoKategorienAdminAction} from '../../../../client-ngrx/veranstaltungen';
import {getAktuelleVeranstaltungId} from './veranstaltungen-info-kategorien.selectors';

@Injectable()
export class EffectsWs {

    @Effect()
    readModelUpdaterInfoKategorien$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VERANSTALTUNG_ENTITY
                && x.message.entity_part.toUpperCase() === VERANSTALTUNG_ENTITY_PART_INFO_KATEGORIE;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <VeranstaltungDetail> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getAktuelleVeranstaltungId)))
        , filter(([x, veranstaltungId]) => {
            return veranstaltungId !== null && x.veranstaltung_id !== null && x.veranstaltung_id !== undefined && x.veranstaltung_id === veranstaltungId;
        })
        , flatMap(([x, ]) => {
            return [new GetVeranstaltungInfoKategorienAdminAction(x.veranstaltung_id)
            ];
        })
    );


    constructor(private actions$: Actions,
                private store: Store<PageState>) {
    }
}
